// extracted by mini-css-extract-plugin
export default {"MatomoLink":"MatomoLink_MatomoLink__d2M9N"};